import { ColDef, ValueFormatterParams } from 'ag-grid-community';

import AbandonButton from '../GridComponents/AbandonButton';
import DownloadAndProcessButtons from '../GridComponents/DownloadAndProcessButtons';
import { FILE_STATUS_COLORS } from '@/config/statuses.config';
import { UpliftUploadedFile } from '../../abstractions/UpliftUploadedFile.interface';
import AgGridStatus, { AgGridStatusParams }
  from '@/components/common/TableGrid/CustomComponents/AgGridStatus/AgGridStatus';
import AgGridMultilineText
  from '@/components/common/TableGrid/CustomComponents/AgGridMultilineText/AgGridMultilineText';
import AgGridDateFormatter
  from '@/components/common/TableGrid/CustomFormatters/AgGridDateFormatter/AgGridDateFormatter';

export default function useColumns() {
  return [
    {
      headerName: 'Uplift Effective Date',
      colId: 'effectiveDate',
      field: 'effectiveDate',
      initialWidth: 170,
      minWidth: 170,
      maxWidth: 170,
      cellClass: 'text-center',
      valueFormatter: AgGridDateFormatter
    },
    {
      headerName: 'File Name',
      colId: 'fileName',
      field: 'fileName',
      initialWidth: 300,
      minWidth: 150,
    },
    {
      headerName: 'Status',
      colId: 'status',
      field: 'status',
      initialWidth: 150,
      minWidth: 150,
      maxWidth: 150,
      cellRenderer: AgGridStatus,
      cellRendererParams: {
        statusColorSchema: FILE_STATUS_COLORS
      } as AgGridStatusParams,
      valueFormatter: ({ data }: ValueFormatterParams<UpliftUploadedFile>) => data?.statusFormatted ?? '-',
      cellClass: 'text-center',
    },
    {
      headerName: 'Message',
      colId: 'errorText',
      field: 'errorText',
      initialWidth: 250,
      maxWidth: 400,
      minWidth: 190,
      cellRenderer: AgGridMultilineText,
      wrapText: true,
      autoHeight: true,
    },
    {
      headerName: '',
      colId: 'downloadAndProcessButtons',
      field: 'downloadAndProcessButtons',
      initialWidth: 280,
      minWidth: 280,
      maxWidth: 280,
      cellRenderer: DownloadAndProcessButtons,
      suppressNavigable: true,
      cellClass: 'ag-cell-no-border-on-focus'
    },
    {
      headerName: '',
      colId: 'abandonButton',
      field: 'abandonButton',
      initialWidth: 125,
      minWidth: 125,
      maxWidth: 125,
      cellRenderer: AbandonButton,
      cellClass: ['ag-cell-no-border-on-focus', 'd-flex', 'justify-content-center'],
      suppressNavigable: true,
    },
  ] as ColDef[];
}
